export default {
    statusCounter: 0,
    getPaymentStatus(unp) {
    

        return new Promise((resolve, reject) => {
            setTimeout(() => {


                let phone = ''

            
                if (unp != '1337') {
                    phone = '8006002134'
                }

                if (unp == '1984') {
                  
                        resolve({
                            payStatus: 'STORNO',
                            unp: '74103123024',
                            account: '300304122',
                            period: 112020,
                            phone: phone,
                            registered: !phone
                    })
             
                return
                }

                if (unp == '451') {
                    reject({ error: "HELLO THERE, GENERAL KENOBI" })
                }
                




                this.statusCounter++

                if (this.statusCounter < 2) {
                    resolve({
                        payStatus: 'SAVED',
                        unp: '74103123024',
                        account: '300304122',
                        period: 112020,
                        phone: phone,
                        registered: !phone
                    })
                } else {
                    this.phoneToReg = null
                    this.statusCounter = 0
                    resolve({
                        payStatus: 'AUTH',
                        unp: '74103123024',
                        account: '300304122',
                    period: 112020,
                        phone: phone,
                        registered: !phone
                    })
                }

            }, 2000);
        });
    }
}